import React from 'react';

import Uploader from '@geneui/components/Uploader';

const FileUploader = ({ onChange, ...restProps }) => {
  return <Uploader className='fileUploader' onChange={e => onChange(e)} {...restProps} />;
};

export default FileUploader;
